const INIT_STATE = {
  getSupplierTallies: [],
  getSupplierTalliesSuccess: "",
  getSupplierTalliesError: "",

  getPrimeBasicSupplier: "",
  getPrimeBasicSupplierSuccess: "",
  getPrimeBasicSupplierError: "",

  getSuppliersList: [], //contains a list of all suppliers
  getSuppliersListSuccess: "",
  getSuppliersListError: "",

  getSupplier: "", //Info of single suppliers
  getSupplierSuccess: "",
  getSupplierError: "",

  deleteSupplierSuccess: "",
  deleteSupplierError: "",

  getSupplierSummary: "",
  getSupplierSummarySuccess: "",
  getSupplierSummaryError: "",

  getSupplierDetails: "",
  supplierDistribution: [],
  getSupplierDetailsSuccess: "",
  getSupplierDetailsError: "",

  primeSupplierDetails: "",
  primeSupplierDetailsSuccess: "",
  primeSupplierDetailsError: "",

  getSupplierPreview: "",
  getSupplierPreviewSuccess: "",
  getSupplierPreviewError: "",

  getSingleSupplierDetails: "",
  getSingleSupplierDetailsSuccess: "",
  getSingleSupplierDetailsError: "",

  insertSupplierDetails: "", //data of suppliers newly added
  insertSupplierDetailsSuccess: "",
  insertSupplierDetailsError: "",

  updateSupplierDetailsSuccess: "",
  updateSupplierDetailsError: "",

  getSupplierContacts: [],
  getSupplierContactsSuccess: "",
  getSupplierContactsError: "",

  addSuppliersContacts: [],
  addSuppliersContactSuccess: "",
  addSuppliersContactError: "",

  updateSuppliersContactSuccess: "",
  updateSuppliersContactError: "",

  deleteSuppliersContactSuccess: "",
  deleteSuppliersContactError: "",

  updateSupplier: "", //data of suppliers that updated
  updateSupplierSuccess: "",
  updateSupplierError: "",

  insertSupplier: "", //data of suppliers newly added
  insertSupplierSuccess: "",
  insertSupplierError: "",

  addSupAttachments: [],
  addSupAttachmentsSuccess: "",
  addSupAttachmentsError: "",

  getSupAttachment: "",
  getSupAttachmentSuccess: "",
  getSupAttachmentError: "",

  deleteSupAttachmentsSuccess: "",
  deleteSupAttachmentsError: "",

  unlockSupplierSuccess: "",
  unlockSupplierError: "",

  approveSupplierSuccess: "",
  approveSupplierError: "",

  moveSupplierSuccess: "",
  moveSupplierError: "",

  declineSupplierSuccess: "",
  declineSupplierError: "",

  holdSupplierSuccess: "",
  holdSupplierError: "",

  getSupplierActivity: [],
  getSupplierActivitySuccess: "",
  getSupplierActivityError: "",

  exportSuppliers: "",
  exportSuppliersSuccess: "",
  exportSuppliersError: "",

  pasteSuppliersSuccess: "",
  pasteSuppliersError: "",

  sendForApprovalSupplierSuccess: "",
  sendForApprovalSupplierError: "",
};

export default function (state = INIT_STATE, action) {
  switch (action.type) {
    //----------------------****Get Supplier Tallies****-----------------------------
    case "GET_SUPPLIER_TALLIES_INIT":
      return {
        ...state,
        getSupplierTallies: [],
        getSupplierTalliesSuccess: "",
        getSupplierTalliesError: "",
      };
    case "GET_SUPPLIER_TALLIES_SUCCESS":
      return {
        ...state,
        getSupplierTallies: action.payload.supplierTallies || [],
        getSupplierTalliesSuccess: action.payload.results[0].description,
      };
    case "GET_SUPPLIER_TALLIES_FAIL":
      return {
        ...state,
        getSupplierTalliesError: action.payload,
      };
    //----------------------****Get Suppliers List****-----------------------------
    case "GET_SUPPLIERS_LIST_INIT":
      return {
        ...state,
        getSuppliersList: [],
        getSuppliersListSuccess: "",
        getSuppliersListError: "",
      };
    case "GET_SUPPLIERS_LIST_SUCCESS":
      return {
        ...state,
        getSuppliersList: action.payload.suppliers || [],
        getSuppliersListSuccess: action.payload.results[0].description,
      };
    case "GET_SUPPLIERS_LIST_FAIL":
      return {
        ...state,
        getSuppliersListError: action.payload,
      };

    //----------------------****Delete supplier ****-------------------
    case "DELETE_SUPPLIER_INIT":
      return {
        ...state,
        deleteSupplierSuccess: "",
        deleteSupplierError: "",
      };
    case "DELETE_SUPPLIER_SUCCESS":
      return {
        ...state,
        deleteSupplierSuccess: action.payload.results[0].description,
      };
    case "DELETE_SUPPLIER_FAIL":
      return {
        ...state,
        deleteSupplierError: action.payload,
      };
    //----------------------****Send For Approval Timecard ****--------
    case "SEND_FOR_APPROVAL_SUPPLIER_INIT":
      return {
        ...state,
        sendForApprovalSupplierSuccess: "",
        sendForApprovalSupplierError: "",
      };
    case "SEND_FOR_APPROVAL_SUPPLIER_SUCCESS":
      return {
        ...state,
        sendForApprovalSupplierSuccess: action.payload.results[0].description,
      };
    case "SEND_FOR_APPROVAL_SUPPLIER_FAIL":
      return {
        ...state,
        sendForApprovalSupplierError: action.payload,
      };

    //----------------------****Get Single Supplier ****-----------------------------
    case "GET_SUPPLIER_INIT":
      return {
        ...state,
        getSupplier: "",
        getSupplierSuccess: "",
        getSupplierError: "",
      };
    case "GET_SUPPLIER_SUCCESS":
      return {
        ...state,
        getSupplier: action.payload,
        getSupplierSuccess: action.payload.results[0].description,
      };
    case "GET_SUPPLIER_FAIL":
      return {
        ...state,
        getSupplierError: action.payload,
      };
    //----------------------****Get Supplier Address ****-----------------------------
    case "GET_SUPPLIER_ADDRESS_INIT":
      return {
        ...state,
        getSupplierAddress: "",
        getSupplierAddressSuccess: "",
        getSupplierAddressError: "",
      };
    case "GET_SUPPLIER_ADDRESS_SUCCESS":
      return {
        ...state,
        getSupplierAddress: action.payload,
        getSupplierAddressSuccess: action.payload.results[0].description,
      };
    case "GET_SUPPLIER_ADDRESS_FAIL":
      return {
        ...state,
        updateSupplierAddressError: action.payload,
      };
    //----------------------****Update Supplier Address  ****-----------------------------
    case "UPDATE_SUPPLIER_ADDRESS_INIT":
      return {
        ...state,
        updateSupplierAddress: "",
        updateSupplierAddressSuccess: "",
        updateSupplierAddressError: "",
      };
    case "UPDATE_SUPPLIER_ADDRESS_SUCCESS":
      return {
        ...state,
        updateSupplierAddress: action.payload,
        updateSupplierAddressSuccess: action.payload.results[0].description,
      };
    case "UPDATE_SUPPLIER_ADDRESS_FAIL":
      return {
        ...state,
        updateSupplierAddressError: action.payload,
      };
    //----------------------****Get Supplier Details****-----------------------------
    case "GET_SUPPLIER_DETAILS_INIT":
      return {
        ...state,
        getSupplierDetails: "",
        supplierDistribution: [],
        getSupplierDetailsSuccess: "",
        getSupplierDetailsError: "",
      };
    case "GET_SUPPLIER_DETAILS_SUCCESS":
      return {
        ...state,
        getSupplierDetails: action.payload.supplier || "",
        supplierDistribution: action.payload.supplierDistribution || [],
        getSupplierDetailsSuccess: action.payload.results[0].description,
      };
    case "GET_SUPPLIER_DETAILS_FAIL":
      return {
        ...state,
        getSupplierDetailsError: action.payload,
      };
    //----------------------**** prime Basic Supplier****-----------------------------
    case "GET_PRIME_BASIC_SUPPLIER_INIT":
      return {
        ...state,
        getPrimeBasicSupplier: [],
        getPrimeBasicSupplierSuccess: "",
        getPrimeBasicSupplierError: "",
      };
    case "GET_PRIME_BASIC_SUPPLIER_SUCCESS":
      return {
        ...state,
        getPrimeBasicSupplier: action.payload || "",
        getPrimeBasicSupplierSuccess: action.payload.results[0].description,
      };
    case "GET_PRIME_BASIC_SUPPLIER_FAIL":
      return {
        ...state,
        getPrimeBasicSupplierError: action.payload,
      };

    //----------------------****get Supplier Preview****-----------------------------

    case "GET_SUPPLIER_PREVIEW_INIT":
      return {
        ...state,
        getSupplierPreview: "",
        getSupplierPreviewSuccess: "",
        getSupplierPreviewError: "",
      };
    case "GET_SUPPLIER_PREVIEW_SUCCESS":
      return {
        ...state,
        getSupplierPreview: action.payload.preview || "",
        getSupplierPreviewSuccess: action.payload.results[0].description,
      };
    case "GET_SUPPLIER_PREVIEW_FAIL":
      return {
        ...state,
        getSupplierPreviewError: action.payload,
      };

    //----------------------****Prime Supplier Details****-----------------------------
    case "PRIME_SUPPLIER_DETAILS_INIT":
      return {
        ...state,
        primeSupplierDetails: "",
        primeSupplierDetailsSuccess: "",
        primeSupplierDetailsError: "",
      };
    case "PRIME_SUPPLIER_DETAILS_SUCCESS":
      return {
        ...state,
        primeSupplierDetails: action.payload.supplier || "",
        primeSupplierDetailsSuccess: action.payload.results[0].description,
      };
    case "PRIME_SUPPLIER_DETAILS_FAIL":
      return {
        ...state,
        primeSupplierDetailsError: action.payload,
      };

    //----------------------****get single Supplier Details****-----------------------------
    case "GET_SINGLE_SUPPLIER_DETAILS_INIT":
      return {
        ...state,
        getSingleSupplierDetails: "",
        getSingleSupplierDetailsSuccess: "",
        getSingleSupplierDetailsError: "",
      };
    case "GET_SINGLE_SUPPLIER_DETAILS_SUCCESS":
      return {
        ...state,
        getSingleSupplierDetails: action.payload || "",
        getSingleSupplierDetailsSuccess: action.payload.results[1].description,
      };
    case "GET_SINGLE_SUPPLIER_DETAILS_FAIL":
      return {
        ...state,
        getSingleSupplierDetailsError: action.payload,
      };
    //----------------------****Insert Supplier Details****-----------------------------
    case "INSERT_SUPPLIER_DETAILS_INIT":
      return {
        ...state,
        insertSupplierDetails: "",
        insertSupplierDetailsSuccess: "",
        insertSupplierDetailsError: "",
      };
    case "INSERT_SUPPLIER_DETAILS_SUCCESS":
      return {
        ...state,
        insertSupplierDetails: action.payload.supplier || "",
        insertSupplierDetailsSuccess: action.payload.results[0].description,
      };
    case "INSERT_SUPPLIER_DETAILS_FAIL":
      return {
        ...state,
        insertSupplierDetailsError: action.payload,
      };
    //----------------------****Update Supplier Details****-----------------------------
    case "UPDATE_SUPPLIER_DETAILS_INIT":
      return {
        ...state,
        updateSupplierDetailsSuccess: "",
        updateSupplierDetailsError: "",
      };
    case "UPDATE_SUPPLIER_DETAILS_SUCCESS":
      return {
        ...state,
        updateSupplierDetailsSuccess: action.payload.results[0].description,
      };
    case "UPDATE_SUPPLIER_DETAILS_FAIL":
      return {
        ...state,
        updateSupplierDetailsError: action.payload,
      };
    //----------------------****Get  Supplier Contacts ****-----------------------------
    case "GET_SUPPLIER_CONTACTS_INIT":
      return {
        ...state,
        getSupplierContacts: [],
        getSupplierContactsSuccess: "",
        getSupplierContactsError: "",
      };
    case "GET_SUPPLIER_CONTACTS_SUCCESS":
      return {
        ...state,
        getSupplierContacts: action.payload.contacts || [],
        getSupplierContactsSuccess: action.payload.results[0].description,
      };
    case "GET_SUPPLIER_CONTACTS_FAIL":
      return {
        ...state,
        getSupplierContactsError: action.payload,
      };

    //----------------------****Update Supplier ****-----------------------------
    case "UPDATE_SUPPLIER_INIT":
      return {
        ...state,
        updateSupplier: "",
        updateSupplierSuccess: "",
        updateSupplierError: "",
      };
    case "UPDATE_SUPPLIER_SUCCESS":
      return {
        ...state,
        updateSupplier: action.payload || "",
        updateSupplierSuccess: action.payload.results[0].description,
      };
    case "UPDATE_SUPPLIER_FAIL":
      return {
        ...state,
        updateSupplierError: action.payload,
      };
    //----------------------****Add Supplier's Contact ****-----------------------------
    case "ADD_SUPPLIER_CONTACT_INIT":
      return {
        ...state,
        addSuppliersContacts: [],
        addSuppliersContactSuccess: "",
        addSuppliersContactError: "",
      };
    case "ADD_SUPPLIER_CONTACT_SUCCESS":
      return {
        ...state,
        addSuppliersContacts: action.payload.contacts || [],
        addSuppliersContactSuccess: action.payload.results[1].description,
      };
    case "ADD_SUPPLIER_CONTACT_FAIL":
      return {
        ...state,
        addSuppliersContactError: action.payload,
      };
    //----------------------****Update Supplier's Contact ****-----------------------------
    case "UPDATE_SUPPLIER_CONTACT_INIT":
      return {
        ...state,
        updateSuppliersContactSuccess: "",
        updateSuppliersContactError: "",
      };
    case "UPDATE_SUPPLIER_CONTACT_SUCCESS":
      return {
        ...state,
        updateSuppliersContactSuccess: action.payload.results[0].description,
      };
    case "UPDATE_SUPPLIER_CONTACT_FAIL":
      return {
        ...state,
        updateSuppliersContactError: action.payload,
      };
    //----------------------****Delete Supplier's Contact ****-----------------------------
    case "DELETE_SUPPLIER_CONTACT_INIT":
      return {
        ...state,
        deleteSuppliersContactSuccess: "",
        deleteSuppliersContactError: "",
      };
    case "DELETE_SUPPLIER_CONTACT_SUCCESS":
      return {
        ...state,
        deleteSuppliersContactSuccess: action.payload.results[0].description,
      };
    case "DELETE_SUPPLIER_CONTACT_FAIL":
      return {
        ...state,
        deleteSuppliersContactError: action.payload,
      };
    //----------------------****Insert Supplier ****-----------------------------
    case "INSERT_SUPPLIER_INIT":
      return {
        ...state,
        insertSupplier: "",
        insertSupplierSuccess: "",
        insertSupplierError: "",
      };
    case "INSERT_SUPPLIER_SUCCESS":
      let successMsg =
        (action.payload.insertSupplierResp &&
          action.payload.insertSupplierResp.results &&
          action.payload.insertSupplierResp.results[0].description) ||
        "Supplier Successfully Inserted.";
      return {
        ...state,
        insertSupplier: action.payload,
        insertSupplierSuccess: successMsg,
      };
    case "INSERT_SUPPLIER_FAIL":
      return {
        ...state,
        insertSupplierError: action.payload,
      };
    //----------------------****Add Supplier's Attachments ****-----------------------------
    case "ADD_SUP_ATTACHMENTS_INIT":
      return {
        ...state,
        addSupAttachments: [],
        addSupAttachmentsSuccess: "",
        addSupAttachmentsError: "",
      };
    case "ADD_SUP_ATTACHMENTS_SUCCESS":
      return {
        ...state,
        addSupAttachments: action.payload.attachments || [],
        addSupAttachmentsSuccess: action.payload.results[0].description,
      };
    case "ADD_SUP_ATTACHMENTS_FAIL":
      return {
        ...state,
        addSupAttachmentsError: action.payload,
      };
    //----------------------****Get Supplier's Attachments ****-----------------------------
    case "GET_SUP_ATTACHMENT_INIT":
      return {
        ...state,
        getSupAttachment: "",
        getSupAttachmentSuccess: "",
        getSupAttachmentError: "",
      };
    case "GET_SUP_ATTACHMENT_SUCCESS":
      return {
        ...state,
        getSupAttachment: action.payload || "",
        getSupAttachmentSuccess: action.payload.results[0].description,
      };
    case "GET_SUP_ATTACHMENT_FAIL":
      return {
        ...state,
        getSupAttachmentError: action.payload,
      };
    //----------------------****Delete Supplier's Attachments ****-----------------------------
    case "DELETE_SUP_ATTACHMENTS_INIT":
      return {
        ...state,
        deleteSupAttachmentsSuccess: "",
        deleteSupAttachmentsError: "",
      };
    case "DELETE_SUP_ATTACHMENTS_SUCCESS":
      return {
        ...state,
        deleteSupAttachmentsSuccess: action.payload.results[0].description,
      };
    case "DELETE_SUP_ATTACHMENTS_FAIL":
      return {
        ...state,
        deleteSupAttachmentsError: action.payload,
      };
    //----------------------****Unlock Supplier ****-----------------------------
    case "UNLOCK_SUPPLIER_INIT":
      return {
        ...state,
        unlockSupplierSuccess: "",
        unlockSupplierError: "",
      };
    case "UNLOCK_SUPPLIER_SUCCESS":
      return {
        ...state,
        unlockSupplierSuccess: action.payload.results[0].description,
      };
    case "UNLOCK_SUPPLIER_FAIL":
      return {
        ...state,
        unlockSupplierError: action.payload,
      };
    //----------------------****Approve Supplier ****-----------------------------
    case "APPROVE_SUPPLIER_INIT":
      return {
        ...state,
        approveSupplierSuccess: "",
        approveSupplierError: "",
      };
    case "APPROVE_SUPPLIER_SUCCESS":
      return {
        ...state,
        approveSupplierSuccess: action.payload.results[0].description,
      };
    case "APPROVE_SUPPLIER_FAIL":
      return {
        ...state,
        approveSupplierError: action.payload,
      };
    //----------------------****move Supplier ****-----------------------------
    case "MOVESUPPLIER_INIT":
      return {
        ...state,
        moveSupplierSuccess: "",
        moveSupplierError: "",
      };
    case "MOVESUPPLIER_SUCCESS":
      return {
        ...state,
        moveSupplierSuccess: action.payload.results[0].description,
      };
    case "MOVESUPPLIER_FAIL":
      return {
        ...state,
        moveSupplierError: action.payload,
      };

    //----------------------****decline Supplier ****-----------------------------
    case "DECLINE_SUPPLIER_INIT":
      return {
        ...state,
        declineSupplierSuccess: "",
        declineSupplierError: "",
      };
    case "DECLINE_SUPPLIER_SUCCESS":
      return {
        ...state,
        declineSupplierSuccess: action.payload.results[0].description,
      };
    case "DECLINE_SUPPLIER_FAIL":
      return {
        ...state,
        declineSupplierError: action.payload,
      };

    //----------------------****hold Supplier ****-----------------------------
    case "HOLD_SUPPLIER_INIT":
      return {
        ...state,
        holdSupplierSuccess: "",
        holdSupplierError: "",
      };
    case "HOLD_SUPPLIER_SUCCESS":
      return {
        ...state,
        holdSupplierSuccess: action.payload.results[0].description,
      };
    case "HOLD_SUPPLIER_FAIL":
      return {
        ...state,
        holdSupplierError: action.payload,
      };
    //----------------------****Get Supplier Activity ****-----------------------------
    case "GET_SUPPLIER_ACTIVITY_INIT":
      return {
        ...state,
        getSupplierActivity: [],
        getSupplierActivitySuccess: "",
        getSupplierActivityError: "",
      };
    case "GET_SUPPLIER_ACTIVITY_SUCCESS":
      return {
        ...state,
        getSupplierActivity: action.payload.activity || [],
        getSupplierActivitySuccess: action.payload.results[0].description,
      };
    case "GET_SUPPLIER_ACTIVITY_FAIL":
      return {
        ...state,
        getSupplierActivityError: action.payload,
      };
    //----------------------****Export Suppliers ****-----------------------------
    case "EXPORT_SUPPLIERS_INIT":
      return {
        ...state,
        exportSuppliers: "",
        exportSuppliersSuccess: "",
        exportSuppliersError: "",
      };
    case "EXPORT_SUPPLIERS_SUCCESS":
      return {
        ...state,
        exportSuppliers: action.payload.export || "",
        exportSuppliersSuccess: action.payload.results[0].description,
      };
    case "EXPORT_SUPPLIERS_FAIL":
      return {
        ...state,
        exportSuppliersError: action.payload,
      };
    //----------------------****get Supplier Summary****-----------------------------
    case "GET_SUPPLIER_SUMMARY_INIT":
      return {
        ...state,
        getSupplierSummary: "",
        getSupplierSummarySuccess: "",
        getSupplierSummaryError: "",
      };
    case "GET_SUPPLIER_SUMMARY_SUCCESS":
      return {
        ...state,
        getSupplierSummary: action.payload.supplierSummary || "",
        getSupplierSummarySuccess: action.payload.results[0].description,
      };
    case "GET_SUPPLIER_SUMMARY_FAIL":
      return {
        ...state,
        getSupplierSummaryError: action.payload,
      };
    //----------------------****Paste Suppliers ****-----------------------------
    case "PASTE_SUPPLIERS_INIT":
      return {
        ...state,
        pasteSuppliersSuccess: "",
        pasteSuppliersError: "",
      };
    case "PASTE_SUPPLIERS_SUCCESS":
      return {
        ...state,
        pasteSuppliersSuccess: action.payload.results[0].description,
      };
    case "PASTE_SUPPLIERS_FAIL":
      return {
        ...state,
        pasteSuppliersError: action.payload,
      };
    //----------------------****To Clear States*****-----------------------------
    case "CLEAR_SUPPLIER_STATES":
      return {
        ...state,

        getSupplierTalliesSuccess: "",
        getSupplierTalliesError: "",

        getSuppliersListSuccess: "",
        getSuppliersListError: "",

        getSupplierSuccess: "",
        getSupplierError: "",

        getSupplierSummarySuccess: "",
        getSupplierSummaryError: "",

        getSupplierDetailsSuccess: "",
        getSupplierDetailsError: "",

        getSupplierPreviewSuccess: "",
        getSupplierPreviewError: "",

        getPrimeBasicSupplierSuccess: "",
        getPrimeBasicSupplierError: "",

        primeSupplierDetailsSuccess: "",
        primeSupplierDetailsError: "",

        insertSupplierDetailsSuccess: "",
        insertSupplierDetailsError: "",

        updateSupplierDetailsSuccess: "",
        updateSupplierDetailsError: "",

        updateSupplierSuccess: "",
        updateSupplierError: "",

        addSuppliersContactSuccess: "",
        addSuppliersContactError: "",

        updateSuppliersContactSuccess: "",
        updateSuppliersContactError: "",

        deleteSuppliersContactSuccess: "",
        deleteSuppliersContactError: "",

        insertSupplierSuccess: "",
        insertSupplierError: "",

        getSupplierContactsSuccess: "",
        getSupplierContactsError: "",

        addSupAttachmentsSuccess: "",
        addSupAttachmentsError: "",

        getSupAttachmentSuccess: "",
        getSupAttachmentError: "",

        deleteSupAttachmentsSuccess: "",
        deleteSupAttachmentsError: "",

        unlockSupplierSuccess: "",
        unlockSupplierError: "",

        approveSupplierSuccess: "",
        approveSupplierError: "",

        moveSupplierSuccess: "",
        moveSupplierError: "",

        declineSupplierSuccess: "",
        declineSupplierError: "",

        holdSupplierSuccess: "",
        holdSupplierError: "",

        getSupplierActivitySuccess: "",
        getSupplierActivityError: "",

        exportSuppliersSuccess: "",
        exportSuppliersError: "",

        pasteSuppliersSuccess: "",
        pasteSuppliersError: "",

        sendForApprovalSupplierSuccess: "",
        sendForApprovalSupplierError: "",
      };
    //----------------------****Clear States When Producton Login****-----------------------------
    case "CLEAR_STATES_WHEN_LOGIN_PRODUCTION":
      //when user login production on dashboard then remove data of previous Production
      return {
        ...state,

        getSupplierTallies: [],
        getSupplierTalliesSuccess: "",
        getSupplierTalliesError: "",

        getSuppliersList: [],
        getSuppliersListSuccess: "",
        getSuppliersListError: "",

        getSupplierSummary: "",
        getSupplierSummarySuccess: "",
        getSupplierSummaryError: "",

        getSupplier: "",
        getSupplierSuccess: "",
        getSupplierError: "",

        getSupplierDetails: "",
        supplierDistribution: [],
        getSupplierDetailsSuccess: "",
        getSupplierDetailsError: "",

        getSupplierPreview: "",
        getSupplierPreviewSuccess: "",
        getSupplierPreviewError: "",

        getPrimeBasicSupplier: [],
        getPrimeBasicSupplierSuccess: "",
        getPrimeBasicSupplierError: "",

        primeSupplierDetails: "",
        primeSupplierDetailsSuccess: "",
        primeSupplierDetailsError: "",

        insertSupplierDetails: "", //data of suppliers newly added
        insertSupplierDetailsSuccess: "",
        insertSupplierDetailsError: "",

        updateSupplierDetailsSuccess: "",
        updateSupplierDetailsError: "",

        updateSupplier: "",
        updateSupplierSuccess: "",
        updateSupplierError: "",

        addSuppliersContacts: [],
        addSuppliersContactSuccess: "",
        addSuppliersContactError: "",

        updateSuppliersContactSuccess: "",
        updateSuppliersContactError: "",

        deleteSuppliersContactSuccess: "",
        deleteSuppliersContactError: "",

        insertSupplier: "",
        insertSupplierSuccess: "",
        insertSupplierError: "",

        getSupplierContacts: [],
        getSupplierContactsSuccess: "",
        getSupplierContactsError: "",

        addSupAttachments: [],
        addSupAttachmentsSuccess: "",
        addSupAttachmentsError: "",

        getSupAttachment: "",
        getSupAttachmentSuccess: "",
        getSupAttachmentError: "",

        deleteSupAttachmentsSuccess: "",
        deleteSupAttachmentsError: "",

        unlockSupplierSuccess: "",
        unlockSupplierError: "",

        approveSupplierSuccess: "",
        approveSupplierError: "",

        moveSupplierSuccess: "",
        moveSupplierError: "",

        declineSupplierSuccess: "",
        declineSupplierError: "",

        holdSupplierSuccess: "",
        holdSupplierError: "",

        getSupplierActivity: [],
        getSupplierActivitySuccess: "",
        getSupplierActivityError: "",

        exportSuppliers: "",
        exportSuppliersSuccess: "",
        exportSuppliersError: "",

        pasteSuppliersSuccess: "",
        pasteSuppliersError: "",

        sendForApprovalSupplierSuccess: "",
        sendForApprovalSupplierError: "",
      };

    //----------------------****Clear States After Logout****-------------------
    case "CLEAR_STATES_AFTER_LOGOUT":
      return {
        ...state,

        getSupplierTallies: [],
        getSupplierTalliesSuccess: "",
        getSupplierTalliesError: "",

        getSuppliersList: [],
        getSuppliersListSuccess: "",
        getSuppliersListError: "",

        getSupplier: "",
        getSupplierSuccess: "",
        getSupplierError: "",

        getSupplierSummary: "",
        getSupplierSummarySuccess: "",
        getSupplierSummaryError: "",

        getSupplierDetails: "",
        supplierDistribution: [],
        getSupplierDetailsSuccess: "",
        getSupplierDetailsError: "",

        getSupplierPreview: "",
        getSupplierPreviewSuccess: "",
        getSupplierPreviewError: "",

        getPrimeBasicSupplier: [],
        getPrimeBasicSupplierSuccess: "",
        getPrimeBasicSupplierError: "",

        primeSupplierDetails: "",
        primeSupplierDetailsSuccess: "",
        primeSupplierDetailsError: "",

        insertSupplierDetails: "", //data of suppliers newly added
        insertSupplierDetailsSuccess: "",
        insertSupplierDetailsError: "",

        updateSupplierDetailsSuccess: "",
        updateSupplierDetailsError: "",

        updateSupplier: "",
        updateSupplierSuccess: "",
        updateSupplierError: "",

        addSuppliersContacts: [],
        addSuppliersContactSuccess: "",
        addSuppliersContactError: "",

        updateSuppliersContactSuccess: "",
        updateSuppliersContactError: "",

        deleteSuppliersContactSuccess: "",
        deleteSuppliersContactError: "",

        insertSupplier: "",
        insertSupplierSuccess: "",
        insertSupplierError: "",

        getSupplierContacts: [],
        getSupplierContactsSuccess: "",
        getSupplierContactsError: "",

        addSupAttachments: [],
        addSupAttachmentsSuccess: "",
        addSupAttachmentsError: "",

        getSupAttachment: "",
        getSupAttachmentSuccess: "",
        getSupAttachmentError: "",

        deleteSupAttachmentsSuccess: "",
        deleteSupAttachmentsError: "",

        unlockSupplierSuccess: "",
        unlockSupplierError: "",

        approveSupplierSuccess: "",
        approveSupplierError: "",

        moveSupplierSuccess: "",
        moveSupplierError: "",

        declineSupplierSuccess: "",
        declineSupplierError: "",

        holdSupplierSuccess: "",
        holdSupplierError: "",

        getSupplierActivity: [],
        getSupplierActivitySuccess: "",
        getSupplierActivityError: "",

        exportSuppliers: "",
        exportSuppliersSuccess: "",
        exportSuppliersError: "",

        pasteSuppliersSuccess: "",
        pasteSuppliersError: "",

        sendForApprovalSupplierSuccess: "",
        sendForApprovalSupplierError: "",
      };
    default:
      return state;
  }
}
